import React from "react";
// import { useNavigate } from "react-router-dom";
import { SiGithub } from "react-icons/si";
import { HiOutlineExternalLink } from "react-icons/hi";
import "../styles/ProjectItem.scss";

function ProjectItem({ image, name, id, description, source, deploy, tags }) {
  // const navigate = useNavigate();
  return (
    <div className="project-item">
      <div style={{ backgroundImage: `url(${image})` }} className="bgImage" />
      <h1>
        {name}
      </h1>
      <div className="tag-list">
        {tags.map((tag) => (
          <div key={`${name}-${tag.name}`} className={`tag ${tag.color}`}>
            {tag.name}
          </div>
        ))}
      </div>
      <p className="description">{description}</p>
      <div className="link-boxes">
        <div
          className="source-code link"
          onClick={() => window.open(source, "_blank")}
        >
          <SiGithub />
        </div>
        <div
          className="deployment link"
          onClick={() => window.open(deploy, "_blank")}
        >
          <HiOutlineExternalLink />
        </div>
      </div>
    </div>
  );
}

export default ProjectItem;
